"use client";

import Link from "next/link";
import { useEffect, useState } from "react";

export default function Navbar() {
  const [isHome, setIsHome] = useState(false);

  useEffect(() => {
    if (document.querySelector(".content-home")) {
      setIsHome(true);
    }
  }, []);

  return (
    <section className="topbar" id="topbar">
      <div className="container">
        <nav className="hornavbar">
          <ul className="hornavbar-list">
            <li className="hornavbar-mainsite">
              <Link href="https://www.indracompany.com/">Indra</Link>
            </li>
            <li>
              {isHome ? (
                <span>Portal de Empleo</span>
              ) : (
                <Link href="/">Portal de Empleo</Link>
              )}
            </li>
          </ul>
        </nav>
      </div>
    </section>
  );
}
